export default ({ children, fromForm = false }) => {
	return (
		<div className="wrapRequiredPoint">
			{!fromForm && <p className="requiredPoint"></p>}
			{children}
		</div>
	);
};
